import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { usePolicy } from 'dashboard/composables/usePolicy';

// Acesso às CHAMADAS por provedor — SEPARADOS. Cada um exige:
//   • o módulo da empresa (`wavoip` / `astracall`) habilitado (Super Admin), E
//   • poder receber — admin/agente padrão sempre podem; funções personalizadas
//     só com a permissão específica.
// Espelha o padrão `moduleAllowed` do Sidebar (feature_modules + checkPermissions).
export function useWhatsappCallAccess() {
  const { currentAccount } = useAccount();
  const { checkPermissions } = usePolicy();

  const moduleOn = key =>
    currentAccount.value?.feature_modules?.[key] !== false;

  const canReceiveWavoipCalls = computed(
    () =>
      moduleOn('wavoip') &&
      checkPermissions(['administrator', 'agent', 'wavoip_calls_receive'])
  );

  const canReceiveAstracallCalls = computed(
    () =>
      moduleOn('astracall') &&
      checkPermissions(['administrator', 'agent', 'astracall_calls_receive'])
  );

  // BCVOZ (PABX Bravotech) — método SEPARADO e independente. Abre o webphone
  // nativo do BCVOZ; convive lado a lado com os demais. É OPT-IN (nasce
  // desligado), então usa `=== true` (não `!== false`).
  const canReceiveBcvozCalls = computed(
    () =>
      currentAccount.value?.feature_modules?.bcvoz === true &&
      checkPermissions(['administrator', 'agent', 'bcvoz_calls_receive'])
  );

  // Ligações SIP (PABX IP) pelo conector do AstraCalls — também OPT-IN. Usa o
  // mesmo softphone (CallDock) do AstraCall, com a linha SIP como sessão.
  const canReceiveSipCalls = computed(
    () =>
      currentAccount.value?.feature_modules?.sip_pabx === true &&
      checkPermissions(['administrator', 'agent', 'sip_pabx_calls_receive'])
  );

  // Ligação WhatsApp OFICIAL via 360Dialog (Calling API). O canal já é gateado por
  // voice_enabled + CHANNEL_VOICE; aqui aplicamos o controle extra de módulo/permissão.
  const canReceiveWhatsapp360Calls = computed(
    () =>
      moduleOn('whatsapp_360_calls') &&
      checkPermissions(['administrator', 'agent', 'whatsapp_360_calls_receive'])
  );

  return {
    canReceiveWavoipCalls,
    canReceiveAstracallCalls,
    canReceiveBcvozCalls,
    canReceiveSipCalls,
    canReceiveWhatsapp360Calls,
  };
}
